import dataApi from '../api/data'

export const getRegions = () => {
  return dataApi.regions
}

export const getRegion = state => {
  return state.global.region || dataApi.regions[0]
}

export const getRegionIndex = state => {
  return state.global.region
}

export const hotProducts = () => {
  return dataApi.hotProducts
}

export const isLogin = state => {
  let userId, token
  userId = window.getCookie('userId')
  token = window.getCookie('token')

  state.auth.isLogin = !!userId && !!token

  return state.auth.isLogin
}

export const getPhone = state => {
  return state.auth.user.phone
}

export const getEmpNum = state => {
  return state.auth.user.employeeNumber
}

export const getUser = state => {
  return state.auth.user
}

export const getToken = state => {
  return state.auth.user.token
}

export const cartNum = state => {
  if (state.carts.info) {
    return state.carts.info.total
  } else {
    return 0
  }
}


export const needLogin = state => {
  return state.global.needLogin
}

export const getCheckout = state => {
  let checkout = state.orderPay.checkout
  if (!checkout || checkout.length === 0) {
    checkout = JSON.parse(window.localStorage.getItem('checkout')) || []
    console.log('=====')
    console.log(checkout)
  }

  return checkout
}

export const getOrder = state => {
  return state.orderPay.order
}

export const getHistory = state => {
  return state.global.history
}

export const currentCompany = state => {
  return state.global.currentCompany
}




// WEBPACK FOOTER //
// ./src/store/getters.js